import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';

import './AccessibilityNav.scss';

let classNames = require('classnames');

const AccessibilityNav = ({ ...props }) => {
  const [showAccess, setShowAccess] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    document.addEventListener('keyup', trapTabKey);
    document.addEventListener('click', handleOutsideClick, false);
    return () => {
      document.removeEventListener('keyup', trapTabKey);
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, []);

  const trapTabKey = (e) => {
    if (document.activeElement.classList.contains('link_access_keys')) {
      setShowAccess(true);
    }
    else {
      setShowAccess(false);
    }
  };

  const handleOutsideClick = (e) => {
    if (e.target.closest('.accessibility_nav')) {
      return;
    }
    setShowAccess(false);
  };

  const onSearchOpen = (e) => {
    e.preventDefault();
    document.querySelector('.search_opener').click();
    setShowAccess(false);
  };

  const onBurgerMenuOpen = (e) => {
    e.preventDefault();
    document.querySelector('.burger_btn').click();
    setShowAccess(false);
  };

  return (
    <div id="accesskeys" className={classNames('accessibility_nav', { 'accessibility': !showAccess })}>
      <div className="inner-container is-flex">
        <span className="text">
          <FormattedMessage id="common.goto_on" />
        </span>
        <ul className="list list-links is-flex">
          <li className="item">
            <a href="#menu" className="link_access_keys link-menu" onClick={onBurgerMenuOpen} aria-label={intl.formatMessage({ id: 'ariaLabel.access_menu' })}>
              <FormattedMessage id="common.menu" />
            </a>
          </li>
          <li className="item">
            <a href="#pagecontent" className="link_access_keys link-content" aria-label={intl.formatMessage({ id: 'ariaLabel.access_content' })}>
              <FormattedMessage id="common.contents" />
            </a>
          </li>
          <li className="item">
            <a href="#search" className="link_access_keys link-search" onClick={onSearchOpen} aria-label={intl.formatMessage({ id: 'ariaLabel.access_searchbar' })}>
              <FormattedMessage id="common.search" />
            </a>
          </li>
          <li className="item">
            <a href="#footer" className="link_access_keys link-footer" aria-label={intl.formatMessage({ id: 'ariaLabel.access_footer' })}>
              <FormattedMessage id="common.footer" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

AccessibilityNav.defaultProps = {
  title: 'Title'
};

AccessibilityNav.propTypes = {
  title: PropTypes.string
};

export default AccessibilityNav;
